/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import Config from "data/config";
import { useModel } from "cms/models/context/use-model";
import { FieldZoneProvider } from "cms/fields/context/provider";
import { Field } from "cms/fields/layout/field";
import { FieldErrorFallback } from "cms/fields/layout/field-error";
import { useCurrentDynamicField } from "cms/fields/dynamic-field";

const FieldZoneLayout = (props) => {

    const displayComponent = props?.displayComponent;
    const editComponent = props?.editComponent;
    
    const { field } = useCurrentDynamicField();
    const name = field?.name;
    const type = field?.type;
    const list = field?.list;
    const values = field?.values;
    const settings = field?.settings;
    
    const { ModelState } = useModel();
    const allCollapsed = ModelState?.allCollapsed;
    const showDebug = Config.Debug.useDebug;

    const initContext = {
        isDirty: false,
        labelDialogOpen: false,
        reuseDialogOpen: false,
        useDefaultVal: false,
        showDebug,
        expanded: !allCollapsed,
    };
    
    if (!field) {
        return null;
    }

    return (
        <FieldZoneProvider initState={initContext}>
            <ErrorBoundary
                FallbackComponent={FieldErrorFallback}
                onReset={() => {
                    // reset the state of your app so the error doesn't happen again
                    location.reload();
                }}
            >
                {!showDebug &&
                    <Field
                        displayComponent={displayComponent}
                        editComponent={editComponent}
                    />
                }
                {showDebug &&
                    <div className='field-zone-debug-header'>
                        <div className='field-zone-debug-header-text'>
                            {name} - {type}{list ? " - (List)" : ""}
                        </div>
                        
                        <Field
                            displayComponent={displayComponent}
                            editComponent={editComponent}
                        />
                        
                        <div style={{ maxWidth: "800px" }}>
                            <details>
                                <summary>Values</summary>
                                <pre style={{
                                    width: "800px",
                                    fontSize: "9px",
                                    border: "1px solid #999999",
                                    maxWidth: "800px",
                                    overflowX: "auto"
                                }}
                                >
                                    {JSON.stringify(values, null, 2)}
                                </pre>
                            </details>
                        </div>
                        <div style={{ maxWidth: "800px" }}>
                            <details>
                                <summary>Settings</summary>
                                <pre style={{
                                    width: "800px",
                                    fontSize: "9px",
                                    border: "1px solid #999999",
                                    maxWidth: "800px",
                                    overflowX: "auto"
                                }}
                                >
                                    {JSON.stringify(settings, null, 2)}
                                </pre>
                            </details>
                        </div>
                    </div>
                }
            </ErrorBoundary>
        </FieldZoneProvider>
    );
};

FieldZoneLayout.displayName = "FieldZoneLayout";
export { FieldZoneLayout };
